module.exports = __webpack_public_path__ + "img/tm4.c03c7693.jpg";